<template>
  <div id="page-item">
    <el-card v-if="product!=null" >
      <div style="display: flex;align-content: space-between;align-items:center;">
        <div style="flex-grow: 4;">
          <el-page-header @back="close()" style="float:left;">
            <div slot="title">
              <span class="hidden-sm-and-down"></span>
            </div>
            <div slot="content">
              <div class="box flex justify-center">
                <InventoryProductTitle :product="product" :vintage="topVintage" :inventoryCode="inventoryCode"/>
              </div>
            </div>
          </el-page-header>
        </div>
        <div style="justify-content:flex-end;">
          <publishButton
            :puidPublished="product.puidPublished"
            :puid="product.puid"
            :lockVersion="product.lockVersion"
            @published="handlePublished"
            @unpublished="handlePublished"/>


          <el-button
            v-if="isReservationModuleActive && canReserveProduct"
            type="primary"
            icon="el-icon-collection-tag"
            @click="openReservationEditor()"
            size="small">
            <span class="hidden-md-and-down">
              {{$t('products.btn.reserve')}}
            </span>
          </el-button>
        </div>
      </div>
        <div style="margin-top:20px;"></div>

        <ProductDetailInfo :product="product" :inventoryId="parseInt(inventoryId)" @editItem="v => $emit('editItem', v)"></ProductDetailInfo>
    </el-card>
    <ReservationEditor :visible="reservationCreatorVisible" :product="productToReserve" @close="closeReservationEditor" @created="updateSelectedProduct" @updated="updateSelectedProduct"></ReservationEditor>
    <!-- <InventoryAdjustmentDialog :dialogVisible.sync="inventoryAdjustmentDialogVisible" @adjusted="updateSelectedProduct" :inventoryId="inventoryId" :product="product"  :productItems="adjustedProductItems" @close="closeInventoryAdjustmentDialog"></InventoryAdjustmentDialog> -->

  </div>
</template>
<script>
import moment from 'moment-timezone'
// import UpdateItemInfoDialog from './update-item-info-dialog.vue'
import InventoryAdjustmentDialog from '@/views/pages/inventory/components/inventory-adjustment-dialog.vue'
import ReservationEditor from '@/components/reservation/reservation-editor'
import ProductDetailInfo from './product-detail-info'
import InventoryProductTitle from '@/views/pages/inventory/components/inventory-product-title'
import { mapActions, mapState, mapGetters } from 'vuex';
import publishButton from './web-publish-button'
export default {
  name: 'Inventory-Product-Detail',
  props: {
		product : {type : Object},
    productItems : [],
    inventoryId : {type : Number}
	},
  data() {
    return {
      activeTabs : 'overview',
      items : [],
      // product : null,
      active_el : null,
      itemListSpan : 24,
      itemDetailSpan:0,
      pageWidth : 0,
      itemDialogVisible : false,
      inventoryAdjustmentDialogVisible: false,
      adjustProduct : null,
      adjustedProductItems : null,
      itemToConfigure : null,
      reservationCreatorVisible : false,
      window: {
        width: 0,
        height: 0
      },
    };
  },components: {
    InventoryProductTitle,
    InventoryAdjustmentDialog,
    ReservationEditor,
    ProductDetailInfo,
    publishButton
  },
  watch : {

  },
	methods: {
    handlePublished (productInventory) {
      this.setSelectedProduct({ selectedProduct: productInventory });
    },
    close(){
      this.$emit('close');
    },
    closeReservationEditor(){
      this.reservationCreatorVisible=false;
    },
    openReservationEditor(){
      this.reservationCreatorVisible=true;
    },
    openInventoryAdjustmentDialog(){
      this.adjustProduct = this.selectedProduct;
      this.adjustedProductItems = this.selectedProductItems;
      this.inventoryAdjustmentDialogVisible=true;
    },
    closeInventoryAdjustmentDialog(){
      this.inventoryAdjustmentDialogVisible = false;
    },

    getTagTypeBasedOnStatus(status){
      if(status.id==1){
        return "info"
      }else if(status.id==2){
        return ""
      }else if(status.id==3){
        return "danger"
      }else  if(status.id==4){
        return "success"
      }else if (status.id==5){
        return "warning"
      }else {
        return "success"
      }
    },
    openPO(purchaseOrderId){
      var index='/inventories/'+this.inventoryId+'/purchase-orders/'+purchaseOrderId;
      this.$router.push(index);
    },
		setPageWidth() {
			this.pageWidth = document.getElementById('page-item').offsetWidth
		},
    __resizeHanlder: _.throttle(function (e) {
			this.setPageWidth();
		}, 700),
    momentAdd(datetime, nbDays){
      return moment(datetime).add(nbDays,'days').format('LL');
    },
    moment(datetime){
			return  moment(datetime).format('LL');
		},
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('inventoryProducts', ['initInventoryProducts','fetchSearchedProducts','setSelectedProduct','setSearchTerms','setSortIcon','setOrderBy','updateSelectedProduct','refreshProduct'])
	},
	computed: {
    canReserveProduct () {
      return _.get(this.inventory, 'code') !== 'SAQ';
    },
    inventoryCode () {
      return _.get(this.inventory, 'code');
    },
    productToReserve () {
      return this.product;
    },
    ...mapState('inventoryProducts', ['products','inventory', 'selectedProduct','selectedProductItems','selectedProductPurchaseOrders','selectedIndex','loading','loadingSelectedProductItems','loadingSelectedProductPurchaseOrders','orderBy','sort_icon','searchTerms','page','pages','limit','count']),
    ...mapGetters('inventoryProducts',['waitingPurchaseOrders', 'isNegative','isPositive','isIntermediary','getSelectedProductId','canReserveSelectedProduct', 'topVintage']),
    ...mapGetters('reservations', ['isReservationModuleActive']),
    ...mapGetters('controlData',['isCMSModuleActivated'])
	},
  mounted(){

  },
  watch: {
  },
	created(){

    window.addEventListener('resize', this.handleResize)
    this.handleResize();
	},
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.product-top-nav{
  height:30px;
}

.active{
  background-color: lighten($background-color, 20%);
  border-radius: 5px;
  box-shadow:none;
  box-shadow: 0 4px 8px 0 rgba(40,40,90,.09),0 1px 3px 0 rgba(0,0,0,.065);
}


.item-list {
  //margin: 0 auto;
  width: 100%;
  padding: 0px 30px;
  box-sizing: border-box;

  .item {
    margin: 10px 0;
    padding: 5px;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .5s .25s;


    .info {
      word-break: break-word;

    }

    &:hover {
      //margin: 15px -20px;
      //padding: 10px;
      background-color: lighten($background-color, 20%);
      border-radius: 5px;
      box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

    }

  }
}


@media (max-width: 1024px) {
  .product-top-nav{
    height:70px;
  }
}
</style>
